import React from 'react';
import { connect } from 'react-redux';
import { Section, Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import CustomerForm from '../Form';
import { createCustomer } from '@resources/Customer/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { createCustomer, visible, onCancel } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createCustomer(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.customer.create',
						defaultMessage:
							'A new Customer has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.customer',
					defaultMessage: 'Create Customer',
				})}
			</Title>
			<Section className="mb-5">
				<CustomerForm {...props} onSubmit={handleSubmit} />
			</Section>
		</Modal>
	);
};

const mapStateToProps = ({
	users,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
	service,
}) => {
	return {
		users,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
		service,
	};
};

export default connect(mapStateToProps, {
	createCustomer,
})(Create);
